export const getAuthToken = user => {
  return new Promise((resolve, reject) => {
    if (!user) {
      reject('No user logged in');
    }
    user.getIdToken().then(
      token => {
        resolve(token);
      },
      error => {
        reject(error);
      }
    );
  });
};
